import { render, staticRenderFns } from "./ColumnManageDialog.vue?vue&type=template&id=5fe5f82e"
import script from "./ColumnManageDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnManageDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ColumnManageDialog.vue?vue&type=style&index=0&id=5fe5f82e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports